// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__2BXUK","icon":"SortAdornment_icon__1GjNL","up":"SortAdornment_up__1XumK","down":"SortAdornment_down__2hqMp","active":"SortAdornment_active__2bQnx"};